// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.GoogleTokens
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr

fun GoogleTokens.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "RH6tMnpJ-UwJILafeQtZ1bc4zmWYSYsY6KitGpF6_ns")
val GoogleTokens_cborSchemaId = ByteString(68, 126, -83, 50, 122, 73, -7, 76, 9, 32, -74, -97, 121, 11, 89, -43, -73, 56, -50, 101, -104, 73, -117, 24, -24, -88, -83, 26, -111, 122, -2, 123)

fun GoogleTokens.Companion.fromCbor(data: ByteArray): GoogleTokens {
    return GoogleTokens.fromDataItem(Cbor.decode(data))
}

val GoogleTokens.Companion.cborSchemaId: ByteString
    get() = GoogleTokens_cborSchemaId

fun GoogleTokens.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("idToken", Tstr(this.idToken))
    builder.put("accessToken", Tstr(this.accessToken))
    return builder.end().build()
}

fun GoogleTokens.Companion.fromDataItem(dataItem: DataItem): GoogleTokens {
    val idToken = dataItem["idToken"].asTstr
    val accessToken = dataItem["accessToken"].asTstr
    return GoogleTokens(
        idToken = idToken,
        accessToken = accessToken,
    )
}
